import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AccountService } from '../../../../../../../services/account/account.service';
import { ProficiencyService } from '../../../../../../../services/proficiency/proficiency.service';
import { Proficiency } from '../../../../../../../models/proficiency';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';

@Component({
  selector: 'app-remove-proficiency-modal',
  templateUrl: './remove-proficiency-modal.component.html',
  styleUrls: ['./remove-proficiency-modal.component.css']
})
export class RemoveProficiencyModalComponent implements OnInit {

  @Input() proficiency: Proficiency;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public loadingRemove = false;
  public errors: any = {};
  public errorMessage = '';

  public serverError: number = null;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
    public proficiencyService: ProficiencyService
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().is_organization_admin) {
      return;
    }
  }

  public handleRemove() {
    this.loadingRemove = true;

    this.errorMessage = '';
    this.errors = {};

    this.proficiency.is_removed = true;

    this.proficiencyService
      .updateProficiency(this.proficiency)
      .then(() => {
        this.savedCallback({
          text: this.proficiency.name + ' removed successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to remove proficiencies.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingRemove = false; });
  }

}
